(() => {
  const initializeRecommendations = () => {
    document.querySelectorAll('[data-fi-rec-root]').forEach((root) => {
      if (root.dataset.recommendationsPerformed === 'true' || root.dataset.fiLoading === 'true') return;

      const loadRecommendations = async () => {
        root.dataset.fiLoading = 'true';

        const url = new URL(root.dataset.url, window.location.origin);
        url.searchParams.set('product_id', root.dataset.productId);
        url.searchParams.set('section_id', root.dataset.sectionId);
        url.searchParams.set('intent', root.dataset.intent || 'related');

        try {
          const response = await fetch(url.toString());
          if (!response.ok) throw new Error('Unable to load recommendations');

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const nextRoot = parsed.querySelector('[data-fi-rec-root]');

          if (nextRoot) root.replaceWith(nextRoot);
        } catch (error) {
          root.classList.add('hidden');
        }
      };

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 500px 0px' });

      observer.observe(root);
    });
  };

  if (!window.fiAklaRecommendationQuickAddBound) {
    window.fiAklaRecommendationQuickAddBound = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-fi-rec-form]');
      if (!form) return;

      event.preventDefault();

      const button = form.querySelector('.fi-rec__cart');
      const status = form.querySelector('[data-fi-rec-status]');
      const id = form.querySelector('[name="id"]')?.value;

      if (!id || button?.disabled) return;

      button.disabled = true;
      button.classList.remove('is-error');

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add item');

        button.classList.add('is-added');
        if (status) status.textContent = 'Added to cart';

        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
        const cart = await cartResponse.json();

        const cartIcon = document.querySelector('cart-icon');
        if (cartIcon?.renderCartBubble) cartIcon.renderCartBubble(cart.item_count);

        const cartItems = document.querySelector('cart-items-component');
        if (cartItems?.fetchCartData) cartItems.fetchCartData();

        window.setTimeout(() => {
          button.classList.remove('is-added');
          button.disabled = false;
          if (status) status.textContent = '';
        }, 1500);
      } catch (error) {
        button.classList.add('is-error');
        button.disabled = false;
        if (status) status.textContent = error.message || 'Unable to add item';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRecommendations, { once: true });
  } else {
    initializeRecommendations();
  }
})();